import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-pine" data-id="element-412" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:py-16" data-id="element-413" data-mp="2bvcvuiy80sm9">
        <p className="eyebrow text-ember" data-id="element-414" data-mp="1wzwzg7a64kmp">Limited-time offer</p>
        <h2 className="mt-3 font-display text-3xl text-paper sm:text-5xl" data-id="element-415" data-mp="1x1rgvbm8dum1">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-416" data-mp="1o7d1za5m4m3g">
          <Countdown tone="dark" data-id="element-417" data-mp="1o6bhyg6mcp9l" />
        </div>
        <p className="mt-5 text-sm text-paper/75" data-id="element-418" data-mp="1sxti520tilti">
          After that the price goes up by{' '}
          <span className="font-bold text-ember" data-id="element-419" data-mp="1e8xdlexyzqxn">$42</span> and stays there.
        </p>
      </div>
    </section>;
}